import type {
  DocumentFormat,
  DocumentResponse,
  SpreadsheetConfig,
  DocumentBlockConfig,
  PresentationConfig,
} from '@mem-ai-hub/shared';
import { apiClient } from './api';

export async function generateDocument(
  messageId: string,
  sessionId: string,
  format: DocumentFormat,
): Promise<DocumentResponse> {
  return apiClient.post<DocumentResponse>('/documents/generate', {
    messageId,
    sessionId,
    format,
  });
}

export async function generateSpreadsheet(
  config: SpreadsheetConfig,
): Promise<DocumentResponse> {
  return apiClient.post<DocumentResponse>('/documents/generate-spreadsheet', config);
}

export async function generateDocumentBlock(
  config: DocumentBlockConfig,
): Promise<DocumentResponse> {
  return apiClient.post<DocumentResponse>('/documents/generate-document', config);
}

export async function generatePresentationBlock(
  config: PresentationConfig,
): Promise<DocumentResponse> {
  return apiClient.post<DocumentResponse>('/documents/generate-presentation', config);
}

export function getDownloadUrl(blobName: string): string {
  return `/api/documents/${blobName}/download`;
}
